module.exports = __webpack_public_path__ + "img/travel_detail_1.cb3e0c6e.svg";